import { useContext } from "react";
import { langContext } from "./api/Lang";

const el = {
    yes: 'Ναι',
    no: 'Όχι',
    cancel: 'Άκυρο',
    cancel2: 'Ακύρωση',
    areYouSure: 'Είσαι σίγουρος/η;',
    change: 'Τροποποίηση',
    delete: 'Διαγραφή',
    create: 'Δημιουργία',
    addNew: 'Προσθήκη',
    collapseAll: 'Σύμπτυξη όλων',
    dateRange: 'Εύρος ημερομηνιών',
    dbKey: 'Κλειδί βάσης',
    dbPath: 'Διαδρομή DB',
    resourceKey: 'Κλειδί',
    order: 'Σειρά',
    titleSection: 'Τίτλος',
    descriptionSection: 'Περιγραφή',
    nameSection: 'Όνομα',
    requiredKey: 'Συμπλήρωσε κλειδί.',
    duplicateKey: 'Το κλειδί υπάρχει ήδη.',
    emptyState: 'Δεν υπάρχουν εγγραφές ακόμα.',
    endDate: 'Ημερομηνία λήξης',
    expandAll: 'Ανάπτυξη όλων',
    startDate: 'Ημερομηνία έναρξης',
    cancelation: 'Ακύρωση',
    cancelConfirm: 'Ναι, Ακύρωση',
    small: 'Μικρή',
    medium: 'Μεσαία',
    large: 'Μεγάλη',
    next: 'Επόμενο',
    continueLabel: 'Συνέχεια',
    completeOrder: 'Ολοκλήρωση Παραγγελίας',
    topup: 'Ανανέωση',
    clearOrder: 'Διαγραφή Παραγγελίας',
    payPackage: 'Αγορά πακέτου σίτισης',
    goToProfile: 'Ο Λογαριασμός μου',
    ok: 'ΟΚ',
    bio: 'Bio',
    vegetarian: 'Χορτοφαγικό',
    glutenFree: 'Χωρίς Γλουτένη',
    frozen: 'Κτψ',
    classroom: 'Τμήμα',
    loading: 'Φόρτωση...',
    loadingAuth: 'Φόρτωση σύνδεσης...',
    generating: 'Δημιουργία...',
    downloadToExcel: 'Λήψη Excel',
    invalidJson: 'Μη έγκυρο JSON.',
    done: 'Ολοκλήρωση',
    save: 'Αποθήκευση',
    reset: 'Επαναφορά',
    saving: 'Αποθήκευση...',
    saved: 'Αποθηκεύτηκε.',
    expired: 'Έχει λήξει',
    endingSoon: 'Λήγει σύντομα',
    active: 'Ενεργό',
    more: 'Περισσότερα',
    discount: 'ΚΕΡΔΙΖΕΙΣ',
    cancelOrder: 'Ακύρωση παραγγελίας',
    payment: 'Πληρωμή',
    downloadInfo: 'Λήψη πληροφοριών',
    removeSchoolAction: 'Αφαίρεση',
    errorTitle: 'Σφάλμα',
    successTitle: 'Επιτυχία',
    navMyAccount: 'Ο λογαριασμός μου',
    navSettings: 'Ρυθμίσεις',
    schoolLogoAlt: 'Λογότυπο σχολείου',
    lunchboxLogoAlt: 'Lunchbox',
    mobileLogoAlt: 'Lunchbox',
    profileImageAlt: 'Προφίλ',
    privacyPolicy: 'Πολιτική Απορρήτου',
    cookiesPolicy: 'Πολιτική Cookies',
    soldOut: 'Εξαντλήθηκε',
    newBadge: 'ΝΕΟ',
};

const en: typeof el = {
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    cancel2: 'Cancel',
    areYouSure: 'Are you sure?',
    change: 'Change',
    delete: 'Delete',
    create: 'Create',
    addNew: 'Add new',
    collapseAll: 'Collapse All',
    dateRange: 'Date range',
    dbKey: 'Db key',
    dbPath: 'DB path',
    resourceKey: 'Key',
    order: 'Order',
    titleSection: 'Title',
    descriptionSection: 'Description',
    nameSection: 'Name',
    requiredKey: 'Enter a key.',
    duplicateKey: 'This key already exists.',
    emptyState: 'No entries yet.',
    endDate: 'End date',
    expandAll: 'Expand All',
    startDate: 'Start date',
    cancelation: 'Cancel',
    cancelConfirm: 'Yes, Cancel',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    next: 'Next',
    continueLabel: 'Continue',
    completeOrder: 'Complete Order',
    topup: 'Top up',
    clearOrder: 'Clear Order',
    payPackage: 'Purchase meal package',
    goToProfile: 'Go to Profile',
    ok: 'OK',
    bio: 'Bio',
    vegetarian: 'Vegetarian',
    glutenFree: 'Gluten free',
    frozen: 'Frozen',
    classroom: 'Classroom',
    loading: 'Loading...',
    loadingAuth: 'Loading authentication...',
    generating: 'Generating...',
    downloadToExcel: 'Download to Excel',
    invalidJson: 'Invalid JSON.',
    done: 'DONE',
    save: 'Save',
    reset: 'Reset',
    saving: 'Saving...',
    saved: 'Saved.',
    expired: 'Expired',
    endingSoon: 'Ending soon',
    active: 'Active',
    more: 'More',
    discount: 'DISCOUNT',
    cancelOrder: 'Cancel Order',
    payment: 'Payment',
    downloadInfo: 'Download info',
    removeSchoolAction: 'Remove',
    errorTitle: 'Error',
    successTitle: 'Success',
    navMyAccount: 'My Account',
    navSettings: 'Settings',
    schoolLogoAlt: 'School logo',
    lunchboxLogoAlt: 'Lunchbox',
    mobileLogoAlt: 'Lunchbox',
    profileImageAlt: 'Profile',
    privacyPolicy: 'Privacy Policy',
    cookiesPolicy: 'Cookies Policy',
    soldOut: 'Sold out',
    newBadge: 'NEW',
};

const commonLangs = { el, en };

export function useStrings() {
    const [lang] = useContext(langContext);

    return commonLangs[lang];
}